<header class="lg:hidden block bg-white px-2 rounded-lg ml-20 my-2 m-auto">
    <div class="w-full flex items-center justify-between gap-2">

        <div [class.hidden]="!isShow" class="w-full h-[100vh] bg-white fixed top-0 right-0 z-[50]">
            <header>
                <ng-container *ngIf="searchBoxService.accommodation() == 'ecolodge';else hotelBackAction">
                    <div (click)="setToggle()" class="flex items-center gap-4 px-4 py-2 pb-0">
                        <i class="ico-ArrowRight text-2xl"></i>
                        <p class="text-lg">
                            بازگشت
                        </p>
                    </div>
                </ng-container>
                <ng-template #hotelBackAction>
                    <div (click)="setToggle();" class="flex items-center gap-4 px-4 py-2 pb-0">
                        <i class="ico-ArrowRight text-2xl"></i>
                        <p class="text-lg">
                            بازگشت
                        </p>
                    </div>
                </ng-template>
            </header>
            <div class="w-full h-[2px] my-2 bg-gray-200"></div>
            <div class="flex flex-col justify-between items-stretch gap-2 p-4">
                <div *ngIf="searchBoxService.accommodation() == 'ecolodge' && isShowAlertCount && !changeDestinationInPdpMobile()"
                    class="w-full h-fit p-2 bg-red-50 flex items-center  rounded-md text-red-500">
                    <i class="ico-InformationCircle mx-1 text-xl bg-red-100 px-1 rounded-full"></i>
                    <span>لطفاً تعداد نفرات را مشخص کنید!</span>
                </div>
                <div class="iho-autocomplete">
                    <div ihoAutocomplete [isMobile]="true">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>
                                {{searchBoxService.accommodation() === 'ecolodge' ? 'نام شهر یا کد آگهی' : 'مقصد یا  هتل'}}
                            </mat-label>
                            <input matInput class="!font-bold" (click)="unfocus()" id="autocompleteinput-pdp"
                                [value]="autocompleteService._selectedItem().name !== undefined ? autocompleteService._selectedItem().name : ''">
                            <mat-icon matPrefix>
                                <i class="p-2 ico-Location text-xl text-gray-500"></i>
                            </mat-icon>
                        </mat-form-field>
                    </div>
                    <div *ngIf="autocompleteService._state() !== 'hide'"
                        class="w-full h-[100vh] bg-white fixed top-0 right-0 z-[55]">
                        <iho-autocomplete />
                    </div>
                </div>
                <div class="iho-datepicker mt-4">
                    <div ihoDatepicker [ecolodePdp]="true" [isMobile]="true"
                        (click)="searchBoxService.accommodation() == 'ecolodge' ? setToggle() : undefined">
                        <div class="flex justify-between gap-2">
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>
                                    تاریخ ورود
                                </mat-label>
                                <input matInput class="!font-bold" [value]="datepickerService._customStartDate()"
                                    readonly>
                                <mat-icon matPrefix>
                                    <i class="p-2 ico-Calender text-xl text-gray-500"></i>
                                </mat-icon>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>
                                    تاریخ خروج
                                </mat-label>
                                <input matInput class="!font-bold" [value]="datepickerService._customEndDate()"
                                    readonly>
                                <mat-icon matPrefix>
                                    <i class="p-2 ico-Calender text-xl text-gray-500"></i>
                                </mat-icon>
                            </mat-form-field>
                        </div>
                    </div>
                    <div *ngIf="datepickerService._state() !== false"
                        class="w-full h-[100vh] mt-2 bg-white fixed top-0 right-0 z-10">
                        <ng-container *ngComponentOutlet="csrStatus()"></ng-container>
                    </div>
                </div>
                <ng-container *ngIf="searchBoxService.accommodation() == 'ecolodge' && !changeDestinationInPdpMobile()">
                    <iho-extra-person-counter
                        [FixedGuestCount]="pdpUiService.hotelInfo()?.PersonCapacity?.FixedGuestCount"
                        [extraPersonData]="pdpUiService.hotelInfo()?.PersonCapacity?.ExtraGuestCount"
                        (extraPersonOutput)="setNop($event)" />
                    <div class="min-h-[150px]" id="pdp-price-details">
                        <ng-template #showLoadingMobileToggle>
                            <div class="flex justify-between">
                                <iho-skeleton height="1.5rem" width="8rem" />
                                <iho-skeleton height="1.5rem" width="5rem" />
                            </div>
                            <div class="w-full mt-3">
                                <iho-skeleton height="2.75rem" width="100%" />

                            </div>
                        </ng-template>

                        <h5 class="text-sm text-blue-500 font-bold flex justify-center items-center p-3">جزییات قیمت
                        </h5>
                        <iho-pdp-price-details (isShowToast)="isShowToast($event)"
                            *ngIf="!showLoadingMobile();else showLoadingMobileToggle" [priceDetails]="priceDetails()" />
                    </div>
                </ng-container>
                <button (click)="search(); setToggle()"
                    *ngIf="searchBoxService.accommodation() !== 'ecolodge' || (searchBoxService.accommodation() == 'ecolodge' && changeDestinationInPdpMobile())"
                    class="w-full mt-2 py-2 font-bold bg-yellow-400 rounded-lg shadow-sm" color="accent">
                    جستجو
                </button>
                <button (click)="searchEcolodge();"
                    *ngIf="searchBoxService.accommodation() == 'ecolodge' && !changeDestinationInPdpMobile()"
                    class="w-full py-2 font-bold bg-blue-500 rounded-lg shadow-sm text-white" color="accent">
                    تایید و ادامه
                </button>
            </div>
        </div>
    </div>
</header>